import { render, staticRenderFns } from "./ImportClient.vue?vue&type=template&id=5b7b365b&scoped=true"
import script from "./ImportClient.vue?vue&type=script&lang=js"
export * from "./ImportClient.vue?vue&type=script&lang=js"
import style0 from "./ImportClient.vue?vue&type=style&index=0&id=5b7b365b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7b365b",
  null
  
)

export default component.exports